export var fontWeight = {
    normal: "400",
    medium: "500",
    bold: "700",
    semibold: "800"
};

//# sourceMappingURL=fontWeight.js.map